

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { BocciaturaConsegnaFase1 } from "src/app/models/dto/bocciaturaFase1.model";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { ExcelService } from "src/app/services/excelService.service";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";

  

@Component({
    selector: "app-note-rework-fase2",
    templateUrl: "./dialog-note_rework_fase2.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogNoteReworkFase2 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected isRespigimento: Boolean;
    protected isTIMSupport: Boolean;
    
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private excelService:ExcelService
    ) {
      this.pratica          = this.config.data.pratica;
      this.isRespigimento   = this.config.data.isRespigimento;
      this.isTIMSupport   = this.config.data.isTIMSupport;
      
      
    }
    ngOnInit() {
    }

   scaricaReport(){
    if(!this.isRespigimento){
      this.excelService.exportNoteReworkFase2ToExcel(this.pratica,"note_rework_fase2_"+this.pratica.cui+".xlsx");
    }else if(this.isTIMSupport){
    
    }else{
      this.excelService.exportNoteInfratelFase2ToExcel(this.pratica,"note_infratel_fase2_"+this.pratica.cui+".xlsx");
    }
    
    this.dialogRef.close({ success: true});
   }
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.dialogRef.close({ success: true});
       }
    }
  
  }